<template>
    <div v-if="this.getShowHideCommentModal" class="ai-pop-up-wrap hide-comment-modal">
        <input type="text" class="hidden" style="height: 0" id="focus-on-me">
        <div class="ai-generate-fields">
            <h3 style="font-size:20px;text-align: center;color:white;">Hide comment from client?</h3>
            <div class="btn-wrap">
              <button class="btn-save" @click.prevent="onYes()"><i class="fa-solid fa-plus"></i>Yes</button>
              <button class="btn-close" @click.prevent="onNo()"><i class="fa-sharp fa-solid fa-xmark"></i>No</button>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('client', ['getShowHideCommentModal']),
  },
  watch: {
    getShowHideCommentModal(val){
        console.log('getShowHideCommentModal @modal:', val);
    },
  },
  methods: {
    onYes(){
        this.$store.commit('client/setHideComment', true);
        this.$store.commit('client/showHideCommentModal', false);
    },
    onNo(){
        this.$store.commit('client/setHideComment', false);
         this.$store.commit('client/showHideCommentModal', false);
    },
  },
};
</script>

<style>
@import './../../assets/scss/components/_social.scss';
</style>